module.exports = __webpack_public_path__ + "img/省级专精特精企业.221e1ca2.png";